import { Link, Text } from '@nerdwallet/currency';
import P from 'prop-types';
import nds from '@nerdwallet/base-styles/classes';
import {
  setTrk,
  TrkTag,
  TrkElement,
} from '@nerdwallet/nw-client-lib/trk-helper';
import classNames from 'classnames';
import styles from './keto-product-card.module.scss';

const WhyThisProduct = ({
  whyThisProductTypeOverride,
  productName,
  productId,
  whyThisProductText,
  whyThisProductMethodologyUrl,
}) => (
  <div
    className={classNames([styles['why-this-product'], nds('margin-bottom-2')])}
  >
    <Text size="small" component="h4">
      Why this {whyThisProductTypeOverride || productName || 'product'} made the
      list
    </Text>
    <Text component="p">{whyThisProductText}</Text>
    <Link
      target="_blank"
      href={setTrk({
        url: whyThisProductMethodologyUrl,
        params: {
          [TrkTag.copy]: 'Read our methodology',
          [TrkTag.element]: TrkElement.hyperlink,
          [TrkTag.location]: 'KetoProductCard__whyThisProduct',
          trk_productId: productId,
        },
      })}
    >
      Read our methodology
    </Link>
  </div>
);

WhyThisProduct.propTypes = {
  whyThisProductTypeOverride: P.string,
  productName: P.string,
  productId: P.string,
  whyThisProductText: P.string,
  whyThisProductMethodologyUrl: P.string,
};

export default WhyThisProduct;
